import { arrayOf, bool, func } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Label, Row } from 'reactstrap';

import CurrencyInput from '../../../generic/CurrencyInput';
import DateRange from '../../../generic/DateRange';
import SubmittableForm from '../../../generic/SubmittableForm';
import TimestampInfo from '../../../generic/TimestampInfo';
import { bookingEntryShape, productShape } from '../../../prop-types';
import { SYSTEM_GENERATED_USER_NAME } from '../../constants';
import ProductSelection from '../ProductSelection';

function BookingEntryForm({ model, products, onChange, onSubmit, newModel }) {
  const {
    debitAmount,
    discount,
    serviceStartDate,
    serviceEndDate,
    productId,
    entryType,
    created,
    lastModified,
    createdBy,
    lastModifiedBy,
  } = model;

  const inputProps = { onChange, readOnly: !onSubmit };
  const isSystemGenerated = createdBy === SYSTEM_GENERATED_USER_NAME;
  return (
    <SubmittableForm onSubmit={onSubmit} id="qa-booking-entry-form">
      <FormGroup row>
        <Label sm={3} for="be-debitAmount" className="required">
          Debit Amount
        </Label>
        <Col sm={2}>
          <CurrencyInput
            id="be-debitAmount"
            name="debitAmount"
            value={debitAmount || 0}
            allowNegative={false}
            {...inputProps}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={3} for="be-discount">
          Discount
        </Label>
        <Col sm={2}>
          <CurrencyInput
            id="be-discount"
            name="discount"
            value={discount || 0}
            allowNegative={false}
            {...inputProps}
          />
        </Col>
      </FormGroup>
      {!newModel && (
        <FormGroup row>
          <Label sm={3} for="be-entryType">
            Type
          </Label>
          <Col sm={2}>
            <span
              id="be-entryType"
              name="entryType"
              className="form-control-plaintext"
            >
              {entryType}
            </span>
          </Col>
        </FormGroup>
      )}
      <FormGroup row id="qa-booking-entry-product-selection">
        <Label sm={3} for="be-productId" className="required">
          Product
        </Label>
        <Col sm={9}>
          <ProductSelection
            products={products}
            selectedProductId={productId}
            onChange={onChange}
            readOnly={!onSubmit || isSystemGenerated}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={3} for="be-serviceDates" className="required">
          Service Date
        </Label>
        <Col sm={9}>
          <DateRange
            id="be-serviceDates"
            startName="serviceStartDate"
            endName="serviceEndDate"
            startDate={serviceStartDate}
            endDate={serviceEndDate}
            {...inputProps}
          />
        </Col>
      </FormGroup>
      {!newModel && (
        <Row className="small mb-4">
          <Col sm="3" />
          <Col sm="9">
            <TimestampInfo
              timestamp={created}
              actionName="created"
              author={createdBy}
              displayAttribute="inline"
            />
            <TimestampInfo
              timestamp={lastModified}
              actionName="lastModified"
              author={lastModifiedBy}
              displayAttribute="inline"
            />
          </Col>
        </Row>
      )}
    </SubmittableForm>
  );
}

BookingEntryForm.propTypes = {
  model: bookingEntryShape.isRequired,
  products: arrayOf(productShape.isRequired).isRequired,
  onChange: func,
  onSubmit: func,
  newModel: bool,
};

BookingEntryForm.defaultProps = {
  onChange: undefined,
  onSubmit: undefined,
  newModel: false,
};

export default BookingEntryForm;
